let sessionAbortController = new AbortController()

export const getSessionAbortSignal = (): AbortSignal => sessionAbortController.signal

export const resetSessionAbortController = (): void => {
  sessionAbortController.abort()
  sessionAbortController = new AbortController()
}
